import React, { useEffect, useState } from "react";
import "./style.scss";
import ModalComponent from "../../../features/ModalComponent";
import { LOGIN_PAGE } from "../../routes";
import { useNavigate } from "react-router-dom";
import AccountActivated from "./AccountActivated";
import useActivationUser from "./hooks/useActivationUser";
import useFacility from "../../../utils/hooks/useFacility";
import { useTranslation } from "react-i18next";

const HandlerModalByUrl: React.FC = () => {
  const [url, setUrl] = useState<string>(window.location.href);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const [title, setTitle] = useState("");
  const navigate = useNavigate();
  const { activateUser } = useActivationUser();
  const facilityIds = useFacility();
  useEffect(() => {
    if (url.includes("activationAccount")) {
      setOpen(true);
      setTitle(t("gratulacje_twoje_konto_jest_juz_aktywne"));
      // activateUser
      //   const queryParameters = window.location.pathname;
      //  console.log(queryParameters)

      const token = url.split("/").pop();
    }
    if (url.includes("purchaseCompleted")) {
      setTitle("");
    }
  }, [facilityIds]);

  return (
    <React.Fragment>
      {/* {open && (
        <ModalComponent
          footer={true}
          open={open}
          acceptText={"Świetnie, zaloguj się"}
          closeModal={() => setOpen(false)}
          title={title}
          onAccept={() => {
            navigate(LOGIN_PAGE);
            setOpen(false);
          }}
        >
         <AccountActivated/>
        </ModalComponent>
      )} */}
    </React.Fragment>
  );
};

export default HandlerModalByUrl;
